import type { HelpFile } from '../../types/help'
import { ProgressBarTestIds } from '../../../testids/ProgressBarTestIds'

export const progressBarHelp: HelpFile = {
  texts: {
    [ProgressBarTestIds.progressBar]: null,
    [ProgressBarTestIds.progressBarLabel]: null,
  },
}
